import { isSupported, type LanguageCode } from './languages';

/**
 * Startup language resolution, extracted pure for testing.
 *
 * Priority: `?lang=` deep link → shared cross-site cookie (signed-out only;
 * a signed-in user's own setting must not be overridden) → this origin's
 * stored choice → browser language.
 *
 * `persist` is true only for the `?lang=` path: a deep-linked language is
 * persisted to localStorage so it survives reloads and param-less navigation.
 * The cookie path does not persist — the cookie itself is the shared record.
 */
export function resolveInitialLanguage(input: {
    queryLang: string | null;
    cookieLang: string | null;
    likelySignedIn: boolean;
    storedLang: string | null;
    browserLang: string;
}): { lang: LanguageCode; persist: boolean } {
    if (isSupported(input.queryLang)) return { lang: input.queryLang, persist: true };
    if (!input.likelySignedIn && isSupported(input.cookieLang)) {
        return { lang: input.cookieLang, persist: false };
    }
    if (isSupported(input.storedLang)) return { lang: input.storedLang, persist: false };
    if (input.browserLang.startsWith('zh')) return { lang: 'zh-TW', persist: false };
    if (input.browserLang.startsWith('ja')) return { lang: 'ja', persist: false };
    return { lang: 'en', persist: false };
}
